import { CoordinatorService } from './coordinator.service';
import { Keyword } from './keyword';
import { KeywordGroup } from './keyword-group';
import { Report } from './report';
import { ScriptBase } from './script-base';

export class ScriptKeyword extends ScriptBase {
    #coords: CoordinatorService;
    #_keyword: Keyword;

    constructor(coords: CoordinatorService, _keyword: Keyword) {
        super(coords, _keyword);
        this.#coords = coords;
        this.#_keyword = _keyword;
    }

    log(prefix = 'Keyword') {
        console.log(`${prefix}:" ${this.#_keyword.source}
            WEIGHT: ${this.#_keyword.weight}
            GROUP: ${this.#_keyword.group.title}`);
        return this;
    }

    addToReport(r: Report) {
        r.addKeywords(this.#_keyword);
    }

    get source() {
        return this.#_keyword.source;
    }

    get weight() {
        return this.#_keyword.weight;
    }

    set weight(value: number) {
        this.#_keyword.weight = value;
    }

    set group(group: KeywordGroup) {
        this.#_keyword.groupId = group.id;
    }

    hitset(isPreview = false) {
        const nH = this.#coords.script$.hitset(isPreview);
               const s = new Set(this.#_keyword.idSet(isPreview ? 'preview' : 'main'));
        return this._hitset(nH, s, isPreview);
    }

    display(isPreview = false) {
        this.hitset(isPreview).display();
        return this;
    }

    json() {
        return this.#_keyword.save();
    }
}
